import leadership1 from '../assets/images/leadership1.png';
import leadership2 from '../assets/images/leadership2.png';
import leadership3 from '../assets/images/leadership3.png';

export default [
  {
    sn: '01',
    img: leadership1
  },
  {
    sn: '02',
    img: leadership2
  },
  {
    sn: '03',
    img: leadership3
  }
];
